export default function PaymentsPage() {
  return <h1>Payments</h1>;
}
